/* GASSISA
 =========================================================================================
 * Descripcion: Datos ficticios para probar el diseno del ticket sin registrar
 *              una venta real.
 *
 *              Se usan en Parametros de Caja > Ticket (vista previa e impresion
 *              de prueba). Los importes cuadran entre si para que la vista previa
 *              sea representativa.
 *
 * Historial de cambios:
 * ---------------------------------------------------------------------------------------
 *    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1       | 20/10/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion
 * ---------------------------------------------------------------------------------------*/

export const TICKET_MUESTRA_PARTIDAS = [
    {
        descripcion: "ARTICULO DE PRUEBA UNO",
        cantidad: 2,
        medida: "M",
        costounitario: 199,
        descuento: 0,
        total: 398,
        vendedorpreventa: "PRUEBA",
        almacenexhibidor: "PISO",
    },
    {
        descripcion: "ARTICULO DE PRUEBA DOS",
        cantidad: 1,
        medida: "G",
        costounitario: 200,
        descuento: 0,
        total: 200,
        vendedorpreventa: "PRUEBA",
        almacenexhibidor: "PISO",
    },
];

export const construirDatosTicketMuestra = ({
    caja = "CAJA-PRUEBA",
    encabezado = "TICKET DE PRUEBA",
    tipopago = "EFECTIVO",
} = {}) => ({
    cabecero: {
        pc: caja,
        remision: "0000",
        usuario: "USUARIO PRUEBA",
        fechaventa: new Date().toISOString(),
        tipopago,
        razonsocial: "CLIENTE DE PRUEBA",
        subtotal: 598,
        iva: 59.8,
        total: 657.8,
        totaltipopago: 657.8,
        totalefectivo: 1000,
        totalcambio: 342.2,
        foliovaleporcambio: 0,
        montovaleporcambio: 0,
    },
    encabezado,
    detalles: TICKET_MUESTRA_PARTIDAS,
});
